import { RecentlyStudiedCourse } from "../../../../../../models/state/userStats";

export function getCourseId(state: RecentlyStudiedCourse) {
  return state.courseId;
}
